import { render, staticRenderFns } from "./InformsDrawer.vue?vue&type=template&id=2b2e1e61"
import script from "./InformsDrawer.vue?vue&type=script&lang=js"
export * from "./InformsDrawer.vue?vue&type=script&lang=js"
import style0 from "./InformsDrawer.vue?vue&type=style&index=0&id=2b2e1e61&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports